import Agents from "../../../jsx/components/Dashboard/Agents/agents";

const AgentsWrapper = () => {
  return <Agents />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(AgentsWrapper);
